export * as sheet from './sheet';

export function formatCurrency (amount, currency, options) {
  let opt = {
    style: 'currency',
    currency: currency,
  };
  if (currency === 'LBP') {
    opt.minimumFractionDigits = 0;
    opt.maximumFractionDigits = 0;
  }

  Object.assign(opt, options);

  return amount
    ? new Intl.NumberFormat('en-US', opt).format(Math.abs(amount))
    : null;
}

export const dateFormat = new Intl.DateTimeFormat('en-US', {
  year: '2-digit',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  timeZone: 'Asia/Beirut',
});


export function sortByDesc(key) {
  return (a, b) => (a[key] < b[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0);
}

export function sortByDateRowNumber() {
  return (a, b) =>
    b.date - a.date ||
    b.rowNumber - a.rowNumber;
}
